import HttpService from "@core/services/http/http.service";
import { Bank, CreateBank, GetListResponse } from "@app/types";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _BankService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Bank>>("/user/api/v1/banks", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public getBanks(signal?: Signal) {
    return HttpService.get<GetListResponse<Bank>>("/user/api/v1/banks", {
      signal,
    });
  }

  public create(createBank: CreateBank) {
    return HttpService.post("/user/api/v1/banks", {
      body: { ...createBank },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public update(bankId: number, createBank: CreateBank) {
    return HttpService.patch(`/user/api/v1/banks/${bankId}`, {
      body: { ...createBank },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public delete(bankId: number) {
    return HttpService.delete(`/user/api/v1/banks/${bankId}`);
  }
}

const BankService = new _BankService();

export default BankService;
